import { container, title } from "assets/jss/material-kit-react.js";

const aboutStyle = {
  container: {
    zIndex: "12",
    color: "#FFFFFF",
    ...container,
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    color: "#FFFFFF",
    textDecoration: "none",
  },
  infoTitle: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    color: "red",
    textDecoration: "none",
    margin: "auto",
  },
  title_black: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    color: "#000000",
    textDecoration: "none",
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "500px",
    margin: "10px auto 0",
  },
  main: {
    background: "#000000",
    position: "relative",
    zIndex: "3",
  },
  aboutSection: {
    height: "100%",
    color: "white",
    display: "inline-grid",
    textAlign: "center",
    position: "relative",
    zIndex: "3",
  },
  description: {
    textAlign: "left",
    columnCount: "1",
    color: "white",
  },
  mobileDescription: {
    textAlign: "left",
    color: "white",
  },
  imgContainer: {
    paddingTop: "3vh",
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    // padding: "5px",
    zIndex: "9999",
    "@media (min-width: 768px)": {
      backgroundImage:
        "linear-gradient(rgba(0,0,0,0.95), rgba(0,0,0,0.99)),url(" +
        require("assets/img/barn_gjerde.jpg") +
        ")",
    },
  },
  item: {
    fontSize: "18px",
    "@media (min-width: 600px)": {
      fontSize: "20px",
    },
    lineHeight: "1.75rem",
    pageBreakInside: "avoid",
  },
  mobileItem: {
    fontSize: "18px",
    lineHeight: "1.75rem",
  },
  mobileContainer: {
    paddingBottom: "3vh",
  },
  aboutContainer: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "80ch",
    padding: "0 24px",
    "@media (min-width: 400px)": {
      padding: "0 3rem",
    },
  },
  aboutTitle: {
    marginBottom: "2.5vh",
    textAlign: "left",
    color: "white",
    fontSize: "34px",
    fontWeight: "400",
    fontFamily: `"Roboto Slab", "Times New Roman", serif`,
    "@media (min-width: 600px)": {
      fontSize: "38px",
    },
    "@media (min-width: 960px)": {
      fontSize: "40px",
    },
    "@media (min-width: 768px)": {
      marginTop: "3vh",
    },
  },
  mainRow: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
  },

  mainColumn: {
    display: "flex",
    flexDirection: "column",
    flexBasis: "100%",
    flex: "1",
  },
  readMore: {
    textAlign: "left",
    padding: "2px",
    margin: "0px",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "1.3rem",
    color: "#F7776E",
    "&:hover": {
      color: "white",
    },
    hideItem: {
      display: "none",
    },
  },

  aboutImgWrapper: {
    width: "100vw",
    display: "none",
    "@media (max-width: 768px)": {
      display: "block",
    },
    margin: "0px",
    position: "relative",
    left: "50%",
    transform: "translateX(-50%)",
    marginTop: "3vh",
  },

  aboutImage: {
    width: "100vw",
    maxWidth: "100vw",
    maxHeight: "360px",
    objectFit: "cover",
  },
  aboutImgCaption: {
    color: "#ababab",
    textAlign: "right",
    marginTop: "4px",
    padding: "0 24px",
    fontSize: "14px",
    "@media (min-width: 400px)": {
      padding: "0 48px",
    },
  },
};

export default aboutStyle;
